// Note: The first file of a module here, must also register the module

import "./add-to-team.component";
import "./team.controller";
import "./team-form.component";
import "./team-info.component";
import "./team-list.component";

import "./autocomplete";
import "./dropdown";
import "./score-board";
import "./tabs";
